import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListSocialPostsV1Request } from './list-social-posts-v1-request';
import type { IListSocialPostsV1Response } from './list-social-posts-v1-response';
import { listSocialPostsV1ResponseSchema } from './list-social-posts-v1-response';

export async function listSocialPostsV1Api({
  channelId,
  status,
  provider,
  query,
  since,
  until,
  limit,
  offset,
}: IListSocialPostsV1Request = {}): Promise<IValidatedResponse<IListSocialPostsV1Response>> {
  return getRequest<IListSocialPostsV1Response>({
    path: '/sys/social/v1/posts',
    schema: listSocialPostsV1ResponseSchema,
    options: { params: { channelId, status, provider, query, since, until, limit, offset } },
  });
}
